import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TargetBlankDirective } from '@app/core/misc/directives/target-blank.directive';

@Component({
  selector: 'app-item-share',
  templateUrl: './item-share.component.html',
  styleUrls: ['./item-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TargetBlankDirective],
})
export class ItemShareComponent {
  protected currentUrl: string = encodeURIComponent(window.location.href);

  protected facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`;
  protected whatsappShareUrl = `https://api.whatsapp.com/send?text=${this.currentUrl}`;
  protected telegramShareUrl = `https://t.me/share/url?url=${this.currentUrl}`;
}
